import { MapObject } from "./map-object";

export class RandoObject extends MapObject {
    
    constructor(public id:number, public type:string, public title:string, public longitude:number, public latitude:number, public altitude:number,
        public url:String, public text:String
    ) {
        super(id, longitude, latitude, title)
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/rando-object.ts